import React, { useEffect, useState } from "react";
import { Table, Checkbox, Button, Affix, message, Spin } from "antd";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { useEdges } from "@xyflow/react";

const AccessPolicySystemSetting = ({ selectedAccessPolicy, onBack, systemSettingsData, onMain, accessPolicyData }) => {
  const [checkedValues, setCheckedValues] = useState({
    objects: { create: false, view: false, delete: false, edit: false },
    fields: { create: false, view: false, delete: false, edit: false },
    layouts: { create: false, view: false, delete: false, edit: false },
    triggers: { create: false, view: false, delete: false, edit: false },
    report: { create: false, view: false, delete: false, edit: false },
    related_list: { create: false, view: false, delete: false, edit: false },
    list_view: { create: false, view: false, delete: false, edit: false },
    approval_process: { create: false, view: false, delete: false, edit: false },
    access_policy: { create: false, view: false, delete: false, edit: false },
    access_policy_group: { create: false, view: false, delete: false, edit: false },
    dashboard: { create: false, view: false, delete: false, edit: false },
    action_button: { create: false, view: false, delete: false, edit: false },
    compact_layout: { create: false, view: false, delete: false, edit: false },
    user_role: { create: false, view: false, delete: false, edit: false },
    approval_request: { create: false, view: false, delete: false, edit: false },
    flow: { create: false, view: false, delete: false, edit: false },
    schedule_job: { create: false, view: false, delete: false, edit: false },
    email_template: { create: false, view: false, delete: false, edit: false },
    organisation_setup: { create: false, view: false, delete: false, edit: false },
    user_group: { create: false, view: false, delete: false, edit: false },
    manage_currencies: { create: false, view: false, delete: false, edit: false },
    recycle_bin: { create: false, view: false, delete: false, edit: false },
    organization_wide_defaults: { create: false, view: false, delete: false, edit: false },
    record_type: { create: false, view: false, delete: false, edit: false },
    ruby_class:{ create: false, view: false, delete: false, edit: false },
    flexi_page:{create: false, view: false, delete: false, edit: false},
    import_records:{create: false, view: false, delete: false, edit: false},
    export_records:{create: false, view: false, delete: false, edit: false},
    setup_button:{create: false, view: false, delete: false, edit: false},
    apps:{create: false, view: false, delete: false, edit: false},

  });

  const [isEditing, setIsEditing] = useState(false); // State to track editing mode
  const [loading, setLoading] = useState(false); // State to track loading status

  const data = [
    { key: "objects", name: "Objects" },
    { key: "fields", name: "Fields" },
    { key: "layouts", name: "Layouts" },
    { key: "triggers", name: "Triggers" },
    { key: "report", name: "Report" },
    { key: "list_view", name: "List Views" },
    { key: "related_list", name: "Related Lists" },
    { key: "approval_process", name: "Approval Process" },
    { key: "access_policy", name: "Access Policy" },
    { key: "access_policy_group", name: "Access Policy Group" },
    { key: "dashboard", name: "Dashboard" },
    { key: "action_button", name: "Action Button" },
    { key: "compact_layout", name: "Compact Layout" },
    { key: "user_role", name: "User Role" },
    { key: "approval_request", name: "Approval Request" },
    { key: "flow", name: "Flow" },
    { key: "schedule_job", name: "Schedule Job" },
    { key: "email_template", name: "Email Template" },
    { key: "organisation_setup", name: "Organisation Setup" },
    { key: "user_group", name: "User Group" },
    { key: "manage_currencies", name: "Manage Currencies" },
    { key: "recycle_bin", name: "Recycle Bin" },
    { key: "organization_wide_defaults", name: "Organisation-Wide Defaults" },
    { key: "record_type", name: "Record Type" },
    { key: "ruby_class", name: "Ruby Class" },
    { key: "flexi_page",name:"Flexi Page"},
    {key: "import_records",name:"Import Records"},
    {key:"export_records",name:"Export Records"},
    {key:"setup_button",name:"Setup Button"},
    {key:"apps",name:"Apps"},
  ];


  useEffect(() => {
    setCheckedValues(systemSettingsData);
  }, [systemSettingsData])


  const handleCheckboxChange = (key, action) => {
    if (!isEditing) return; // Do nothing if not in edit mode

    setCheckedValues((prev) => {
      const newCheckedValues = { ...prev };
      console.log("newCheckedValues", newCheckedValues);
      console.log("key", key);
      console.log("action", action);

      if (!newCheckedValues[key]) {
        newCheckedValues[key] = {
          view: false,
          edit: false,
          create: false,
          delete: false
        };
      }

      // Toggle the selected action
      newCheckedValues[key][action] = !newCheckedValues[key][action];

      // Apply the logic based on selected action
      if (action === "edit" && newCheckedValues[key][action]) {
        newCheckedValues[key].view = true; // If edit is selected, view should also be selected
      } else if (action === "create" && newCheckedValues[key][action]) {
        newCheckedValues[key].view = true; // If create is selected, view should also be selected
        newCheckedValues[key].edit = true; // If create is selected, edit should also be selected
      } else if (action === "delete" && newCheckedValues[key][action]) {
        newCheckedValues[key].view = true; // If delete is selected, view should be selected
      }

      return newCheckedValues;
    });
  };

  const handleSelectAllChange = (action) => {
    if (!isEditing) return; // Do nothing if not in edit mode

    const allSelected = data.every(
      (record) => checkedValues[record.key][action]
    );
    const newCheckedValues = { ...checkedValues };

    // Toggle select all for the specified action across all categories
    data.forEach((record) => {
      // Logic to handle select all
      newCheckedValues[record.key][action] = !allSelected;

      // Ensure dependent checkboxes are selected too
      if (action === "create" && !allSelected) {
        newCheckedValues[record.key].view = true;
        newCheckedValues[record.key].edit = true;
      } else if (action === "edit" && !allSelected) {
        newCheckedValues[record.key].view = true;
      } else if (action === "delete" && !allSelected) {
        newCheckedValues[record.key].view = true;
      }
    });

    setCheckedValues(newCheckedValues);
  };

  const saveSystemSetting = async () => {



    try {
      setLoading(true);
      accessPolicyData.system_settings = checkedValues;
      const apiService = new ApiService(
        `${BASE_URL}/update_access_policy/${selectedAccessPolicy}`,
        { 'Content-Type': 'application/json' },
        'PATCH',
        accessPolicyData
      );
      const response = await apiService.makeCall();
      message.success('System Settings Successfully updated');
      setIsEditing(false);
      onMain();
    }
    catch (error) {
      message.error('Error updating system settings');
    }
    finally {
      setLoading(false);
    }
  };

  const cancelEditing = () => {
    // Handle cancel action
    setIsEditing(false); // Disable edit mode on cancel
  };

  const handleBack = () => {
    if (isEditing) {
      message.warning('Please save the settings');
      return;
    }
    setIsEditing(false); // Disable edit mode on cancel
    onBack();
  }

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: (
        <div>
          <Checkbox
            checked={data?.every((record) => checkedValues[record?.key]?.view)}
            onChange={() => handleSelectAllChange("view")}
            style={{ marginRight: "5px" }}
            disabled={!isEditing} // Disable checkbox if not in edit mode
          />
          View
        </div>
      ),
      key: "view",
      render: (_, record) => (
        <Checkbox
          checked={checkedValues[record.key]?.view}
          onChange={() => handleCheckboxChange(record.key, "view")}
          disabled={!isEditing} // Disable checkbox if not in edit mode
        />
      ),
    },
    {
      title: (
        <div>
          <Checkbox
            checked={data.every((record) => checkedValues[record.key]?.create)}
            onChange={() => handleSelectAllChange("create")}
            style={{ marginRight: "5px" }}
            disabled={!isEditing} // Disable checkbox if not in edit mode
          />
          Create
        </div>
      ),
      key: "create",
      render: (_, record) => (
        <Checkbox
          checked={checkedValues[record.key]?.create}
          onChange={() => handleCheckboxChange(record.key, "create")}
          disabled={!isEditing} // Disable checkbox if not in edit mode
        />
      ),
    },
    {
      title: (
        <div>
          <Checkbox
            checked={data.every((record) => checkedValues[record.key]?.edit)}
            onChange={() => handleSelectAllChange("edit")}
            style={{ marginRight: "5px" }}
            disabled={!isEditing} // Disable checkbox if not in edit mode
          />
          Edit
        </div>
      ),
      key: "edit",
      render: (_, record) => (
        <Checkbox
          checked={checkedValues[record.key]?.edit}
          onChange={() => handleCheckboxChange(record.key, "edit")}
          disabled={!isEditing} // Disable checkbox if not in edit mode
        />
      ),
    },
    {
      title: (
        <div>
          <Checkbox
            checked={data.every((record) => checkedValues[record.key]?.delete)}
            onChange={() => handleSelectAllChange("delete")}
            style={{ marginRight: "5px" }}
            disabled={!isEditing} // Disable checkbox if not in edit mode
          />
          Delete
        </div>
      ),
      key: "delete",
      render: (_, record) => (
        <Checkbox
          checked={checkedValues[record.key]?.delete}
          onChange={() => handleCheckboxChange(record.key, "delete")}
          disabled={!isEditing} // Disable checkbox if not in edit mode
        />
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '10px' }}>
          <h2 style={{ margin: 0 }}>System Settings</h2>

          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              type="default"
              onClick={handleBack}
            >
              Back
            </Button>

            <Button
              type="primary"
              onClick={() => setIsEditing(!isEditing)}
            >
              {isEditing ? "Cancel Edit" : "Edit"}
            </Button>
          </div>
        </div>



        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="key"
          style={{ marginBottom: "20px", height: '80vh', overflowY: 'scroll' }}
        />

        {isEditing && (
          <Affix offsetBottom={0}>
            <div
              style={{
                position: "sticky",
                bottom: 0,
                background: "rgba(240, 242, 245, 0.9)",
                padding: "10px 0",
                boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
              }}
            >
              <Button type="primary" onClick={saveSystemSetting} style={{ marginRight: 10 }}>
                Save
              </Button>
              <Button type="default" onClick={cancelEditing}>
                Cancel
              </Button>
            </div>
          </Affix>
        )}
      </div>
    </Spin>
  );
};

export default AccessPolicySystemSetting;
